import { actionCreator } from '@ardoq/rxbeach';
import { APIScopeData } from '@ardoq/api-types';

export const setTagsFromScenario = actionCreator<APIScopeData['tags']>(
  '[tagScape] setTagsFromScenario'
);
